import * as React from 'react';
import styled from 'styled-components';
//import icon from './icon-menu-9dot.svg';
import icon from './icon-menu-line3.svg';
import icon_white from './icon-menu-line3-white.svg';
import icon_close from './icon-menu-close.svg';
import { MainMenu } from './MainMenu';
import { openAiChatWidget } from 'util/ssqutil';
import { useZstdInfo } from 'zstd/useZstdInfo';
import { useWinResize } from 'zstd/useZstdWinResize';

type Props = {
  main: boolean;
  mobile?: boolean;
  headerRef?: React.RefObject<HTMLDivElement>;
};
export const MainMenuIcon = (props: Props) => {
  const [localShow, setLocalShow] = React.useState(false);

  const { main, mobile, headerRef } = props;

  const { showMobileMenu, setShowMobileMenu } = useZstdInfo();
  const { isMobile } = useWinResize();

  // 헤더 활성화(X 전환/드롭다운 헤더하단 부착)는 실제 모바일 뷰포트(≤764px)에서만.
  // 태블릿(765~1199px)은 MobileMenuIcon이 노출되지만 기존처럼 로컬 드롭다운으로 동작한다.
  const mobileMode = Boolean(mobile) && isMobile;
  //  - 보이는 흰색 Header(main=false) 인스턴스가 드롭다운 렌더와 닫기(X)를 담당.
  //  - 투명 MainHeader(main=true) 인스턴스는 여는 트리거 역할만 하고 드롭다운을 렌더하지 않는다
  //    (흰색 Header가 덮어쓰므로 중복 렌더/바깥클릭 충돌 방지).
  const isMobileCtrl = mobileMode && !main;
  const open = mobileMode ? showMobileMenu : localShow;
  const renderMenu = mobileMode ? isMobileCtrl && showMobileMenu : localShow;
  const showClose = isMobileCtrl && showMobileMenu;

  const changeShow = (next: boolean) => {
    if (mobileMode) setShowMobileMenu(next);
    else setLocalShow(next);
  };

  React.useEffect(() => {
    return () => {
      if (mobile) setShowMobileMenu(false);
    };
  }, []);

  const handleClickAiChatbot = () => {
    changeShow(false);
    // openAiChatWidget()으로 AI Chatbot v2 위젯 오픈 (기존 PopAiChatbot 대체)
    openAiChatWidget();
  };
  return (
    <Body>
      <button
        onMouseDown={(e) => e.stopPropagation()}
        onClick={() => changeShow(!open)}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
      >
        <Icon src={showClose ? icon_close : main ? icon_white : icon} />
      </button>
      {renderMenu && (
        <div style={{ position: 'relative' }}>
          <MainMenu
            onClose={() => changeShow(false)}
            top={main ? 0.4 : 0}
            main={main}
            belowHeader={isMobileCtrl}
            headerRef={headerRef}
            onClickAiChatbot={handleClickAiChatbot}
          />
        </div>
      )}
    </Body>
  );
};

const Icon = styled.img`
  width: 2.4rem;
  height: 2.4rem;
`;

const Body = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
`;
